import React, { useState, useEffect, useContext } from "react";
import Labeled from "common/Labeled";
import ActionsContext from "common/ActionsContext";
import ChoiceOrValue from "common/ChoiceOrValue";

const doesNothing = () => {};

const options = [
  { value: "any", label: "Any" },
  { value: "spec", label: "Specify Port Number:" },
];

const Default = ({ value, name }) => (
  <input type="hidden" value={value} name={name} />
);

export const PortInput = ({
  name,
  defaultSelectValue = "spec",
  defaultValue = "any",
  onChange = doesNothing,
}) => {
  const [hidden, setHidden] = useState(true);
  const actions = useContext(ActionsContext);

  useEffect(
    () =>
      actions.recv("protocol-changed", (protocol) =>
        setHidden(protocol !== "tcp" && protocol !== "udp")
      ),
    []
  );
  return hidden ? (
    <Default name={name} value={defaultValue} />
  ) : (
    <ChoiceOrValue
      name={name}
      options={options}
      defaultValue={defaultValue}
      defaultSelectValue={defaultSelectValue}
      onChange={onChange}
      type="number"
      min={0}
      max={65335}
      hideArrows={true}
    />
  );
};

export const LabeledPortInput = ({ ...settings }) => (
  <Labeled {...settings}>
    <div className="margin-l-10 flex-100">
      <PortInput {...settings} />
    </div>
  </Labeled>
);
export default LabeledPortInput;
